export const UNAUTHORIZED_STATUS = 401;
export const UNPROCESSABLE_CONTENT = 422;
export const CONTENT_TOO_LARGE = 413;
export const INTERNAL_SERVER_ERROR = 500;
